export default __webpack_public_path__ + "static/media/ic-credit-card.12874680.svg";